import { ICategory } from '../../../utils/types';
import { ICategoryForm } from '../types';
import { parseCategoryButton } from '../../Category/utils/parseCategoryButton';

export const parseHistoryState = (): ICategoryForm | undefined => {
    const data: ICategory | undefined = globalThis.history.state?.usr?.category;
    if (!data?.id) {
        return;
    }

    return {
        id: data.id,
        name: data.name,
        parent: data.parent,
        description: data.description,
        alias: data.alias,
        img: data.img?.length && {
            src: data.img[0],
            alt: data.img[1],
            title: data.img[2],
        },
        hero: data.hero,
        keywords: data.keywords?.split(', '),
        metaDescription: data.metaDescription,
        metaTitle: data.metaTitle,
        filtersGroup: data.filtersGroup?.map((item) => item.id),
        buttons: parseCategoryButton(data.buttons),
        visible: !data.deletedAt,
    };
};
